import { Link } from 'react-router-dom'
import './SupplierCards.css'

function SupplierCards({ suppliers = [], selectedIds = [], onChange, disabled = false }) {
  const toggleSupplier = (supplierId) => {
    if (disabled) return
    
    const isSelected = selectedIds.includes(supplierId)
    if (isSelected) {
      onChange(selectedIds.filter(id => id !== supplierId))
    } else {
      onChange([...selectedIds, supplierId])
    }
  }

  const selectAll = () => {
    if (disabled) return
    onChange(suppliers.map(s => s.email))
  }

  const clearAll = () => {
    if (disabled) return
    onChange([])
  }

  return (
    <div className="supplier-cards-container">
      <div className="supplier-cards-header">
        <span className="supplier-count">
          {selectedIds.length} de {suppliers.length} seleccionados
        </span>
        <div className="supplier-cards-actions">
          <button
            type="button"
            onClick={selectAll}
            className="supplier-action-btn"
            disabled={disabled}
          >
            Seleccionar todos
          </button>
          <button
            type="button"
            onClick={clearAll}
            className="supplier-action-btn"
            disabled={disabled}
          >
            Limpiar
          </button>
        </div>
      </div>
      
      <div className="supplier-cards-grid">
        {suppliers.map((supplier) => {
          const isSelected = selectedIds.includes(supplier.email)
          return (
            <div
              key={supplier.email}
              className={`supplier-card ${isSelected ? 'selected' : ''} ${disabled ? 'disabled' : ''}`}
              onClick={() => toggleSupplier(supplier.email)}
            >
              <div className="supplier-card-checkbox">
                <input
                  type="checkbox"
                  checked={isSelected}
                  onChange={() => toggleSupplier(supplier.email)}
                  disabled={disabled}
                />
              </div>
              <div className="supplier-card-content">
                <h4 className="supplier-card-name">{supplier.name}</h4>
                {supplier.businessName && (
                  <p className="supplier-card-business">{supplier.businessName}</p>
                )}
                {supplier.email && (
                  <p className="supplier-card-email">{supplier.email}</p>
                )}
                {supplier.phone && (
                  <p className="supplier-card-phone">{supplier.phone}</p>
                )}
              </div>
              {isSelected && (
                <div className="supplier-card-check">
                  ✓
                </div>
              )}
            </div>
          )
        })}
      </div>

      {suppliers.length === 0 && (
        <div className="no-suppliers-message">
          <p>No hay proveedores disponibles.</p>
          <Link to="/admin/proveedores/nuevo">Crear proveedor</Link>
        </div>
      )}
    </div>
  )
}

export default SupplierCards
